/**
 * Core UI Icons
 * 
 * Essential navigation, modal, and form controls used throughout the app.
 * These icons are loaded immediately at app startup.
 * 
 * Used by: Navigation, modals, buttons, forms, dropdowns
 */

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faChevronUp as fasChevronUp,
  faChevronDown as fasChevronDown,
  faChevronLeft as fasChevronLeft,
  faChevronRight as fasChevronRight,
  faDownload as fasDownload,
  faBars as fasBars,
  faCheckCircle as fasCheckCircle,
  faSpinner as fasSpinner,
  faTimes as fasTimes,
  faCog as fasCog,
  faArrowsRotate as fasArrowsRotate,
  faGripVertical as fasGripVertical,
  faArrowAltCircleRight as fasArrowAltCircleRight,
  faLock as fasLock,
  faPencil as fasPencil,
  faMicrophoneSlash as fasMicrophoneSlash,
  faMicrophone as fasMicrophone,
  faCircleExclamation as fasCircleExclamation,
  faEllipsisVertical as fasEllipsisVertical,
  faCircle as fasCircle,
  faDash as fasDash,
  faEllipsis as fasEllipsis,
  faScrewdriverWrench as fasScrewdriverWrench,
  faWrench as fasWrench,
  faRepeat as fasRepeat,
  faArchive as fasArchive,
  faArrowDown as fasArrowDown,
  faArrowRight as fasArrowRight,
  faUsers as fasUsers
} from "@fortawesome/pro-solid-svg-icons";

import {
  faChevronLeft as fadChevronLeft,
  faChevronUp as fadChevronUp,
  faChevronDown as fadChevronDown,
  faChevronRight as fadChevronRight,
  faBars as fadBars,
  faCheckCircle as fadCheckCircle,
  faSpinner as fadSpinner,
  faLock as fadLock,
  faPencil as fadPencil,
  faTrash as fadTrash,
  faArrowLeft as fadArrowLeft,
  faArrowUp as fadArrowUp,
  faArrowDown as fadArrowDown,
  faDownload as fadDownload,
  faTimes as fadTimes,
  faSearch as fadSearch,
  faEllipsis as fadEllipsis,
  faMagnifyingGlass as fadMagnifyingGlass,
  faCircle as fadCircle,
  faDash as fadDash,
  faCog as fadCog,
  faCogs as fadCogs,
  faExclamationCircle as fadExclamationCircle,
  faInfoCircle as fadInfoCircle,
  faQuestionCircle as fadQuestionCircle,
  faCircleXmark as fadCircleXmark,
  faCircleCheck as fadCircleCheck,
  faPlus as fadPlus,
  faMinus as fadMinus,
  faWarning as fadWarning,
  faTriangleExclamation as fadTriangleExclamation,
  faExpand as fadExpand,
  faCompress as fadCompress,
  faSpinnerThird as fadSpinnerThird,
  faEye as fadEye,
  faEyeSlash as fadEyeSlash,
  faBan as fadBan,
  faSave as fadSave,
  faCircleHalfStroke as fadCircleHalfStroke,
  faArrowRight as fadArrowRight,
  faUserClock as fadUserClock,
  faMapLocationDot as fadMapLocationDot,
  faNewspaper as fadNewspaper,
  faCheck as fadCheck,
  faBoxArchive as fadBoxArchive,
} from "@fortawesome/pro-duotone-svg-icons";

import {
  faSpinner as falSpinner,
} from "@fortawesome/pro-light-svg-icons";

import {
  faSpinner as fatSpinner,
} from "@fortawesome/pro-thin-svg-icons";

export const loadCoreIcons = () => {
  // Solid variants
  library.add(
    fasChevronUp,
    fasChevronDown,
    fasChevronLeft,
    fasChevronRight,
    fasDownload,
    fasBars,
    fasCheckCircle,
    fasSpinner,
    fasTimes,
    fasCog,
    fasArrowsRotate,
    fasGripVertical,
    fasArrowAltCircleRight,
    fasLock,
    fasPencil,
    fasMicrophoneSlash,
    fasMicrophone,
    fasCircleExclamation,
    fasEllipsisVertical,
    fasCircle,
    fasDash,
    fasEllipsis,
    fasScrewdriverWrench,
    fasWrench,
    fasRepeat,
    fasArchive,
    fasArrowDown,
    fasArrowRight,
    fasUsers
  );

  // Duotone variants
  library.add(
    fadChevronLeft,
    fadChevronUp,
    fadChevronDown,
    fadChevronRight,
    fadBars,
    fadCheckCircle,
    fadSpinner,
    fadLock,
    fadPencil,
    fadTrash,
    fadArrowLeft,
    fadArrowUp,
    fadArrowDown,
    fadDownload,
    fadTimes,
    fadSearch,
    fadEllipsis,
    fadMagnifyingGlass,
    fadCircle,
    fadDash,
    fadCog,
    fadCogs,
    fadExclamationCircle,
    fadInfoCircle,
    fadQuestionCircle,
    fadCircleXmark,
    fadCircleCheck,
    fadPlus,
    fadMinus,
    fadWarning,
    fadTriangleExclamation,
    fadExpand,
    fadCompress,
    fadSpinnerThird,
    fadEye,
    fadEyeSlash,
    fadBan,
    fadSave,
    fadCircleHalfStroke,
    fadArrowRight,
    fadUserClock,
    fadMapLocationDot,
    fadNewspaper,
    fadCheck,
    fadBoxArchive,
  );

  // Light variants
  library.add(falSpinner);

  // Thin variants
  library.add(fatSpinner);
};
